import { CSSTransition } from 'react-transition-group';
import { ModalContent } from '~/components/collections';
import { rage, useObservable } from '~/rage';
import { ModalSurface } from '~/shared';
import { StyledModalWrapper } from './Modal.styled';

const Modal = () => {
	const modalState = useObservable(rage.modal.getCurrentModal());

	const isVisible = !!modalState && modalState.surface === ModalSurface.Tablet;

	return (
		<CSSTransition
			timeout={300}
			classNames={'modal'}
			in={isVisible}
			unmountOnExit
		>
			<StyledModalWrapper>
				{!!modalState && <ModalContent state={modalState} />}
			</StyledModalWrapper>
		</CSSTransition>
	);
};

export { Modal };
